export default {
    'grapesjs-object-fit': {
        'fill': 'Remplir',
        'contain': 'Contenir',
        'cover': 'Couvrir',
        'none': 'Aucun',
        'scale-down': 'Ajuster',
    },
};
